import BackTings from "../components/BackTings"
import Footer from "../components/Footer"
import FormBackThigs from "../components/FormBackThigs"


const ThingsBack = () => {
  return (
    <>
        <BackTings/>
        <FormBackThigs/>
        <Footer/>
    </>
  )
}

export default ThingsBack